import { useState, useEffect, useRef  } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faEye,
  faCircleChevronRight,
  faCircleChevronLeft,
  faFilter,
  faUndo,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import Datepicker from "react-tailwindcss-datepicker";
import { accessBankToken, authanticatedUser, convertToAblDate, formatBirthdayTime, formatMoney } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getMyAblAccounts } from "../../redux/actions/accounts";
import { getCustomerStatement, printStatement } from "../../redux/actions/statements";
import { toast } from "react-toastify";
// import { useDownloadExcel  } from 'react-export-table-to-excel';
import html2pdf from 'html2pdf.js';
import * as types from '../../redux/types'
import * as XLSX from 'xlsx';
import platform from "platform";
import axios from "axios";

const StatementsTable = () => {

  const dispatch = useDispatch()
  const { loading, accounts } = useSelector((state) => state.accounts);
  const { statementLoading, statement } = useSelector((state) => state.statement);
  const [currentPage, setCurrentPage] = useState(1);
  const [accountNumber, setAccountNumber] = useState(false);
  const itemsPerPage = 30;
  const [format, setFormat] = useState("");
  const [info, setInfo] = useState({});
  const [ip, setIp] = useState('')
  // const [showPassword, setShowPassword] = useState(false);
  const [browserName, setBrowserName] = useState("");

  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });


    const getData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json").catch((errr) => {
      // console.log(errr);
    });
    setIp(res.data.ip);
  }; 

  useEffect(() => {
    setBrowserName(platform.name);
    getData();
  }, [dispatch])

  useEffect(() => {
    dispatch({ type: types.RESET_STATEMENT });
  }, []);

  useEffect(() => {
    dispatch({ type: types.RESET_STATEMENT });
    dispatch(getMyAblAccounts({token:authanticatedUser.token, clientNumber: authanticatedUser.clientNumber, ablToken: accessBankToken}));
  }, [dispatch]);

  const getMyCustomStatement = () => {
    if(!value.startDate || !value.endDate){
      toast.error('Date range is reqired to get bank statement.')
      return;
    }

    if(!accountNumber){
      toast.error('Please select an account to get bank statement.')
      return;
    }
    const tmpStat = {
      accountNumber,
      from: convertToAblDate(value.startDate),
      to: convertToAblDate(value.endDate),
      ablToken: accessBankToken,
      token: authanticatedUser?.token
    }

    dispatch(getCustomerStatement(tmpStat))
  }


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = statement?.transactions?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(statement?.transactions?.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const handleAccount = (value) => {
    const account = JSON.parse(value);
     setAccountNumber(account.accountNumber);
     setInfo(account)
  }
  

  const getPageNumbers = () => {
    let startPage = Math.max(1, currentPage - 4);
    let endPage = Math.min(totalPages, startPage + 9);

    if (endPage - startPage < 9) {
      startPage = Math.max(1, endPage - 9);
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };


  // export to pdf and excel
  const tableRef = useRef(null);

  const newExportToPDF = () => {
    // Create the full table HTML (ignoring pagination)
    const fullTableHtml = `
      <div>
        <div style="width: 100%; padding: 50px; margin-bottom: 50px; ">
            <img src="/assets/ablLogo2.png" alt="AccessBank Logo" />
          
          <div style="float: right; text-align: right;">
            <p>Account Nmae: ${accounts?.customerName}</p>
            <p>Account #: ${info?.accountNumber} - ${info?.currency}</p>
            <p>Date:  ${formatBirthdayTime(value?.startDate)} - ${formatBirthdayTime(value?.endDate)}</p>
          </div>
        <div>
        <div style="width: 100%; height: 50px;"></div>

        <table border="1" style="width: 100%; border-collapse: collapse; border-width: 1px; margin-top: 50px; ">
          <thead>
            <tr style="border-width: 1px;">
              <th>Transactions Date</th>
              <th>Description</th>
              <th>Vouchar Number</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            ${statement?.transactions?.map(
                (item) => `
              <tr >
                <td style="font-size: 13px; ">${item?.transactionValueDate}</td>
                <td style="font-size: 13px; ">${item.description1 + ' ' + item.description2} </td>
                <td style="font-size: 13px; ">${item?.voucherNumber}</td>
                <td style="font-size: 13px; ">${item?.transactionType}</td>
                <td style="font-size: 13px; ">${item?.debitAmount
                              ? `-${item?.debitAmount}`
                              : item?.creditAmount} </td>
                <td style="font-size: 13px; ">${item.balance}</td>
              </tr>
            `
              )
              .join("")}
              <tr>
                
                <td></td>
                <td></td>
                <td></td>
                <td>Balance</td>
                <td style="float: right; text-align: right;">${formatMoney(info.balance, info.currency)} </td>
              </tr>
          </tbody>
        </table>
      </div>
    `;


    const tmpPrintStat = {
      accountNumber,
      ip,
      statement: true,
      browserName,
      token: authanticatedUser?.token
    }

    dispatch(printStatement(tmpPrintStat))

    // Create a hidden div to hold the full table for export
    const element = document.createElement("div");
    element.innerHTML = fullTableHtml;

    // Set up html2pdf options
    const options = {
      margin: 10,
      filename: "Bank-statement.pdf",
      html2canvas: { scale: 2 }, // Improve image quality
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
    },
    };

    // Generate PDF from the full table HTML
    html2pdf()
      .from(element)
      .set(options)
      .save();
  };

  // const { onDownload } = useDownloadExcel({
  //   currentTableRef: tableRef.current,
  //   filename: "Bank Statement",
  //   sheet: "Statement"
  // });

  const downExcel = () => {
    // const ws = XLSX.utils.table_to_sheet(document.getElementById('table-to-export'));
    const newArrow = []
    const item = statement?.transactions

    for ( let i=0; i<statement?.transactions?.length; i++) {
      newArrow.push({'Transaction Date': item[i]?.transactionValueDate, Discription: item[i].description1 + ' ' + item[i].description2 ,Voucher: item[i]?.voucherNumber, Type: item[i]?.transactionType, Amount: item[i]?.debitAmount ? item[i]?.debitAmount : item[i]?.creditAmount, Balance: item[i].balance})
    }
    

     const tmpPrintStat = {
      accountNumber,
      ip,
      browserName,
      statement: true,
      token: authanticatedUser?.token
    }

    dispatch(printStatement(tmpPrintStat))


    const ws = XLSX.utils.json_to_sheet(newArrow);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'BankStatement.xlsx');
  }



  return (
    <div className="flex flex-col w-full">
      <div className="mt-10 mb-5 px-4 py-6 bg-white border-0 border-transparent border-solid shadow-soft-xl rounded-2xl bg-clip-border">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-end">
          <div className="lg:col-span-3">
            <label
              htmlFor="accountNumbers"
              className="block text-lg font-bold text-primary-dark mb-2"
            >
             {loading ? 'Loading Accounts': 'Select Account' }
            </label>
         
            <select id="accountNumbers" onChange={e => handleAccount(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
               <option selected>Select Account Number</option>
               {accounts?.accounts?.map((account, i) =>
                <option value={`{"accountNumber": "${account?.accountNumber}", "currency": "${account?.currency}", "balance": "${account.balance}", "internalAccountNumber": "${account.internalAccountNumber}" }`} key={i}>{account?.accountNumber + ' - ' + account?.currency}</option> 
              )}
            </select>
          </div>

          <div className="lg:col-span-4">
            <label
              htmlFor="dateRange"
              className="block text-lg font-bold text-primary-dark mb-2"
            >
              Date Range
            </label>
            <Datepicker
              value={value}
              onChange={newValue => setValue(newValue)}
              inputClassName="w-full pl-5 py-3 rounded-md border border-gray-300 text-primary shadow-sm focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-nowrap justify-between items-stretch space-y-2 sm:space-y-0 sm:space-x-2">
            <button
              type="button"
              onClick={() => getMyCustomStatement()}
              className="px-4 py-2 lg:py-4 font-bold text-center bg-gradient-to-tl from-primary to-brand-4 uppercase rounded-lg text-white text-xs shadow-md hover:shadow-lg transition-all duration-200 flex-grow"
            >
              <FontAwesomeIcon icon={faFilter} className="mr-2" />
              {statementLoading ? 'Loading' : 'Filter'}
            </button>
            <button
              type="button"
              // onClick={resetFilters}
              className="px-4 py-2 lg:py-4 font-bold text-center bg-gradient-to-tl from-brand-1 to-secondary uppercase rounded-lg text-white text-xs shadow-md hover:shadow-lg transition-all duration-200 flex-grow"
            >
              <FontAwesomeIcon icon={faUndo} className="mr-2" />
              Reset
            </button>
            <select id="downloadStatement" onChange={e => setFormat(e.target.value)} value={format} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option selected>Select Format</option>
                        <option value='pdf'>PDF</option> 
                        <option value='excel'>Excel</option> 
                          
                    
                      </select>
            <button onClick={format === 'excel' ? downExcel : newExportToPDF} id="dropdownHoverButton" data-dropdown-toggle="dropdownHover" data-dropdown-trigger="hover" className="text-white bg-primary hover:bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" type="button"><FontAwesomeIcon icon={faDownload} className="mr-2" /> Download 
            </button>



          </div>
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        <div className="bg-white shadow-soft-xl rounded-2xl overflow-hidden">
          <div className="p-6 pb-0 mb-0 bg-white border-b">
            <h1 className="text-primary text-2xl md:text-4xl font-extrabold">
              Bank Statements
            </h1>
          </div>

          <div className="flex-auto px-0 pt-0 pb-2">
            <div className="p-0 overflow-x-auto"  >
              <table ref={tableRef} id="table-to-export" className="items-center w-full mb-0 align-top border-gray-300 text-slate-500"  >
                <thead className="bg-brand-2">
                  <tr>
                    <th className="px-6 py-3 font-bold text-left uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base border-b-solid tracking-none whitespace-nowrap text-white">
                      Date
                    </th>
                    <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base border-b-solid tracking-none whitespace-nowrap text-white">
                      Description
                    </th>
                    
                    <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base border-b-solid tracking-none whitespace-nowrap text-white">
                      Voucher Number
                    </th>
                    <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base border-b-solid tracking-none whitespace-nowrap text-white">
                      Type
                    </th>
                    <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base border-b-solid tracking-none whitespace-nowrap text-white">
                      Amount
                    </th>
                    <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base border-b-solid tracking-none whitespace-nowrap text-white">
                      Balance
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.map((transaction, i) => (
                    <tr key={i}>
                      <td className="p-2 align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                        <p className="mb-0 text-xs font-semibold leading-tight text-primary">
                          {transaction.transactionValueDate}
                        </p>
                      </td>
                      <td className="p-2 align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                        <p className="mb-0 text-xs font-semibold leading-tight text-primary">
                          {transaction.description1}
                          {transaction.description2 && <br />}
                          {transaction.description2}
                        </p>
                      </td>
                      <td className="p-2 text-sm text-center align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                        <span className="text-xs font-semibold leading-tight text-primary">
                          {transaction.voucherNumber}
                        </span>
                      </td>
                      <td className="p-2 text-sm leading-normal text-center align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                        <span
                          className={`bg-gradient-to-tl ${
                            transaction.transactionType === "DEPOSIT"
                              ? "from-primary to-primary-light"
                              : "from-secondary-light to-secondary"
                          } px-2.5 text-xs rounded-1.8 py-1.4 inline-block whitespace-nowrap text-center align-baseline font-bold uppercase leading-none text-white`}
                        >
                          {transaction.transactionType}
                        </span>
                      </td>
                      <td className="p-2 text-center align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                        <span className="text-xs font-semibold leading-tight text-primary">
                          {transaction.debitAmount
                            ? `-${transaction.debitAmount}`
                            : transaction.creditAmount}
                        </span>
                      </td>
                      <td className="p-2 text-center align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                        <span className="text-xs font-semibold leading-tight text-primary">
                          {transaction.balance}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full mt-4">
        <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-white rounded-lg shadow">
          <div className="text-sm font-semibold text-primary mb-2 sm:mb-0">
            Showing {indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, statement?.transactions?.length)} of{" "}
            {statement?.transactions?.length} results
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className={`rounded-md p-1 ${
                currentPage === 1
                  ? "text-gray-300 cursor-not-allowed"
                  : "text-primary hover:bg-gray-100"
              }`}
            >
              <FontAwesomeIcon icon={faCircleChevronLeft} className="text-xl" />
            </button>
            <div className="flex space-x-1">
              {getPageNumbers().map((number) => (
                <button
                  key={number}
                  onClick={() => paginate(number)}
                  className={`px-3 py-1 rounded-md text-sm ${
                    currentPage === number
                      ? "bg-primary text-white"
                      : "bg-gray-200 text-primary hover:bg-gray-300"
                  }`}
                >
                  {number}
                </button>
              ))}
            </div>
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`rounded-md p-1 ${
                currentPage === totalPages
                  ? "text-gray-300 cursor-not-allowed"
                  : "text-primary hover:bg-gray-100"
              }`}
            >
              <FontAwesomeIcon
                icon={faCircleChevronRight}
                className="text-xl"
              />
            </button>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default StatementsTable;
